// EngineTypePlaySmart  = 1  // playsmart
// EngineTypePhaser     = 2  // phaser(qc)
// EngineTypeLayabox    = 3  // layabox
// EngineTypeEgret      = 4  // 白鹭引擎
// EngineTypeThreeJS    = 5  // three.js
// EngineTypeMWEndCard  = 6  // mw_endcard
// EngineTypePlaySmart2 = 7  // PT版本的playsmart
// EngineTypeCocos = 8       // Cocos 引擎
// EngineTypeUnknown    = 99 // 未知引擎
export const engineType = {
  playsmart: 1,
  qc: 2,
  layabox: 3,
  egret: 4,
  threejs: 5,
  // https://gitlab.mobvista.com/playable/gm_endcard
  mwEndcard: 6,
  playsmart2: 7,
  Cocos: 8,
  unknown: 99
}

// 默认字体不需要去请求字体裁切接口
export const defaultFont = 'Arial'
